import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { configureAmplify } from './amplify'
import { GoogleTagManager } from './components/GoogleTagManager'
import { loadAppConfig } from './lib/app-config'
import i18n from './i18n'
import './index.css'

async function bootstrap() {
  const config = await loadAppConfig()
  configureAmplify(config)

  const { default: App } = await import('./App')

  const rootElement = document.getElementById('root')!
  const tree = (
    <React.StrictMode>
      <HelmetProvider>
        <GoogleTagManager />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </React.StrictMode>
  )

  // Prerendered HTML only exists for English routes; anything else
  // (a returning visitor with a different stored locale) re-renders from scratch.
  if (rootElement.hasChildNodes() && i18n.language === 'en') {
    ReactDOM.hydrateRoot(rootElement, tree)
  } else {
    rootElement.innerHTML = ''
    ReactDOM.createRoot(rootElement).render(tree)
  }
}

void bootstrap()
